/**
 *  SplashScene
 *
 *  Created by Legman on 24/02/2017.
 *
 */

import Common           from "./Common";
import ScanlinesFilter  from "./ScanlinesFilter";

/**
 * @class
 */
export default class SplashScene extends p3.Scene {
    constructor() {
        super();

        /**
         * @member {p3.Button}
         * @private
         */
        this._homeButton = null;

        /**
         * @member {p3.Button}
         * @private
         */
        this._muteButton = null;

        /**
         * @member {p3.Button}
         * @private
         */
        this._playButton = null;

        /**
         * @member {PIXI.Sprite}
         * @private
         */
        this._steve = null;

        /**
         * @member {PIXI.Sprite}
         * @private
         */
        this._jar = null;

        /**
         * @member {PIXI.Sprite}
         * @private
         */
        this._base = null;

        /**
         * @member {PIXI.Sprite}
         * @private
         */
        this._monitorLeft = null;

        /**
         * @member {PIXI.Sprite}
         * @private
         */
        this._monitorRight = null;

        /**
         * @member {PIXI.Sprite}
         * @private
         */
        this._title = null;
    }

    init() {
        super.init();

        const assets = Common.assets;

        const bg = new PIXI.Sprite(assets.getTexture("bg_splash"));
        this.addChild(bg);

        this._monitorLeft = new PIXI.Sprite(assets.getTexture("splash_mg_l"));
        this._monitorLeft.x = Common.STAGE_WIDTH * 0.5;
        this._monitorLeft.y = Common.STAGE_HEIGHT * 0.5 + 84;
        this._monitorLeft.anchor = new PIXI.Point(0.5, 0.5);
        this._monitorLeft.visible = false;
        this.addChild(this._monitorLeft);

        this._monitorRight = new PIXI.Sprite(assets.getTexture("splash_mg_r"));
        this._monitorRight.x = Common.STAGE_WIDTH * 0.5;
        this._monitorRight.y = Common.STAGE_HEIGHT * 0.5 + 84;
        this._monitorRight.anchor = new PIXI.Point(0.5, 0.5);
        this._monitorRight.visible = false;
        this.addChild(this._monitorRight);

        this._base = new PIXI.Sprite(assets.getTexture("splash_mg"));
        this._base.x = p3.View.width * 0.5;
        this._base.y = Common.STAGE_HEIGHT * 0.5 + 84;
        this._base.anchor = new PIXI.Point(0.5, 0.5);
        this.addChild(this._base);

        this._steve = new PIXI.Sprite(assets.getTexture("splash_monkey"));
        this._steve.x = p3.View.width * 0.5;
        this._steve.y = this._base.y;
        this._steve.anchor = new PIXI.Point(0.5, 0.5);
        this._steve.visible = false;
        this.addChild(this._steve);

        this._jar = new PIXI.Sprite(assets.getTexture("splash_fg"));
        this._jar.x = p3.View.width * 0.5;
        this._jar.y = this._base.y;
        this._jar.anchor = new PIXI.Point(0.5, 0.5);
        this._jar.visible = false;
        this.addChild(this._jar);

        this._jar.light = new PIXI.Sprite(assets.getTexture("splash_fg_on"));
        this._jar.light.anchor = new PIXI.Point(0.5, 0.5);
        this._jar.light.visible = false;
        this._jar.addChild(this._jar.light);

        this._title = new PIXI.Sprite(assets.getTexture("title"));
        this._title.x = p3.View.width * 0.5;
        this._title.y = Common.STAGE_HEIGHT * 0.5 - 320;
        this._title.anchor = new PIXI.Point(0.5, 0.5);
        this._title.visible = false;
        this.addChild(this._title);

        let states = new p3.ButtonStates();
        states.normal = assets.getTexture("btn_small_off");
        states.icon = assets.getTexture("icon_home_off");

        this._homeButton = new p3.Button(states);
        this._homeButton.x = 100;
        this._homeButton.y = (Common.STAGE_HEIGHT - p3.View.height) * 0.5 + 100;
        this._homeButton.visible = false;
        this._homeButton.overSoundName = "sfx_btn_press_00";
        this._homeButton.clickSoundName = "sfx_btn_home_00";
        this._homeButton.signals.click.add(this.onHomeButtonClick, this);
        this.addChild(this._homeButton);

        states = new p3.ButtonStates();
        states.normal = assets.getTexture("btn_small_off");
        states.icon = assets.getTexture("icon_sound_off");
        states.iconAlt = assets.getTexture("icon_mute_off");

        this._muteButton = new p3.MuteButton(states);
        this._muteButton.x = p3.View.width - 100;
        this._muteButton.y = (Common.STAGE_HEIGHT - p3.View.height) * 0.5 + 100;
        this._muteButton.visible = false;
        this._muteButton.overSoundName = "sfx_btn_press_00";
        this._muteButton.clickSoundName = "sfx_btn_home_00";
        this.addChild(this._muteButton);

        states = new p3.ButtonStates();
        states.normal = assets.getTexture("btn_large_off");
        states.icon = assets.getTexture("icon_large_play_off");

        this._playButton = new p3.Button(states);
        this._playButton.x = p3.View.width * 0.5;
        this._playButton.y = Common.STAGE_HEIGHT * 0.5 + 380;
        this._playButton.visible = false;
        this._playButton.overSoundName = "sfx_btn_press_00";
        this._playButton.downSoundName = "sfx_btn_home_00";
        this._playButton.signals.click.add(this.onPlayButtonClick, this);
        this.addChild(this._playButton);
    }

    destroy() {
        super.destroy();
    }

    appear() {
        super.appear();
    }

    /**
     * @param {function} [callback]
     * @param {*} [scope]
     */
    animateIn(callback, scope) {
        // home button
        /*
        this._homeButton.scale = new PIXI.Point();
        TweenMax.to(this._homeButton.scale, 0.34, {
            delay: 0.1,
            x: 1.0,
            y: 1.0,
            ease: Back.easeOut,
            easeParams: [2],
            onStart: function() {
                this._homeButton.visible = true;
            },
            onStartScope: this
        });
        */

        // mute button
        this._muteButton.scale = new PIXI.Point();
        TweenMax.to(this._muteButton.scale, 0.34, {
            delay: 0.1,
            x: 1.0,
            y: 1.0,
            ease: Back.easeOut,
            easeParams: [2],
            onStart: function() {
                this._muteButton.visible = true;
            },
            onStartScope: this
        });

        // play button
        this._playButton.scale = new PIXI.Point();
        TweenMax.to(this._playButton.scale, 0.34, {
            x: 1.0,
            y: 1.0,
            ease: Back.easeOut,
            easeParams: [3],
            onStart: function() {
                this._playButton.visible = true;
            },
            onStartScope: this
        });

        // jar
        let to = this._jar.y;
        this._jar.y -= 80;
        this._jar.alpha = 0;
        TweenMax.to(this._jar, 0.34, {
            delay: 0.24,
            y: to,
            alpha: 1,
            ease: Power2.easeOut,
            onStart: function() {
                this._jar.visible = true;
            },
            onStartScope: this,
            onComplete: function() {
                // light
                this._jar.light.alpha = 0;
                TweenMax.to(this._jar.light, 0.1, {
                    alpha: 1,
                    ease: Power2.easeInOut,
                    yoyo: true,
                    repeat: 1,
                    onStart: function() {
                        this._jar.light.visible = true;
                        Common.audio.playSound("sfx_results_reveal_00");
                    },
                    onStartScope: this,
                    onComplete: function() {
                        this._jar.light.alpha = 1;
                    },
                    onCompleteScope: this
                })
            },
            onCompleteScope: this
        });

        // steve
        to = this._steve.y;
        this._steve.y -= 80;
        this._steve.alpha = 0;
        TweenMax.to(this._steve, 0.34, {
            y: to,
            alpha: 1,
            ease: Power2.easeOut,
            onStart: function() {
                this._steve.visible = true;
            },
            onStartScope: this,
            onComplete: function() {
                Common.audio.playSound("sfx_steve_00");
            }
        });

        // monitor left
        to = this._monitorLeft.x;
        this._monitorLeft.x -= 200;
        TweenMax.to(this._monitorLeft, 0.34, {
            delay: 0.2,
            x: to,
            ease: Power2.easeOut,
            onStart: function() {
                this._monitorLeft.visible = true;
            },
            onStartScope: this
        });

        // monitor right
        to = this._monitorRight.x;
        this._monitorRight.x += 200;
        TweenMax.to(this._monitorRight, 0.34, {
            delay: 0.2 + 0.1,
            x: to,
            ease: Power2.easeOut,
            onStart: function() {
                this._monitorRight.visible = true;
            },
            onStartScope: this
        });

        // title
        this._title.scale = new PIXI.Point();
        TweenMax.to(this._title.scale, 0.4, {
            delay: 0.34,
            x: 1,
            y: 1,
            ease: Back.easeOut,
            easeParams: [2],
            onStart: function() {
                this._title.visible = true;
            },
            onStartScope: this
        })
    }

    /**
     * @param {function} [callback]
     * @param {*} [scope]
     */
    animateOut(callback, scope) {
    }

    resize() {
        this.y = (p3.View.height - Common.STAGE_HEIGHT) * 0.5;
    }

    update() {
    }

    /**
     * @param {p3.Button} button
     */
    onHomeButtonClick(button) {
    }

    /**
     * @param {p3.Button} button
     */
    onPlayButtonClick(button) {
        this.signals.next.dispatch(this);
    }
}
